export default {
  init() {
    // JavaScript to be fired on all pages

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $(".hamburger").click(function () {
      $(".hamburger").toggleClass('is-active');
      $("#sideNav").toggleClass('sideNav-open');
      $(".sideNavBody").toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $(".sideNav").click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
         $(".hamburger").removeClass('is-active');
         $("#sideNav").removeClass('sideNav-open');
         $(".sideNavBody").removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);


    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $("html, body").animate({
        scrollTop: 0,
      }, 600);
      return false;
    });


    $('.testimonial-slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: '<i class="far fa-angle-right arrow-right"></i>',
      prevArrow: '<i class="far fa-angle-left arrow-left"></i>',
      appendArrows: '.testimonial-panel .slider-nav',
      appendDots: '.testimonial-panel .slider-nav',
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js